/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliActivityDto } from '../../models/amoxcalli-activity-dto';

export interface ApiActivitiesIdGet$Json$Params {
  id: string;
}

export function apiActivitiesIdGet$Json(http: HttpClient, rootUrl: string, params: ApiActivitiesIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliActivityDto>> {
  const rb = new RequestBuilder(rootUrl, apiActivitiesIdGet$Json.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliActivityDto>;
    })
  );
}

apiActivitiesIdGet$Json.PATH = '/api/activities/{id}';
